export default __webpack_public_path__ + "static/media/shareiconemailprofile.445dbcfb.svg";